export default __webpack_public_path__ + "static/banner-5-tips-for-finding-the-best-shopping-deals-dfedaf581d666065fe785fa13f79d439.jpg";